module.exports = __webpack_public_path__ + "img/train-wheels-shadow-1.8b220342.png";